// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"820222f7","787":"bcde1367"}[chunkId] + ".chunk.js";
};